import { Colors } from 'src/com/sixdee/crbtportal/utils/resources/colors';
import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../../toolkit/uicomponentcss';

export interface MyProfileDetailsCSSStyle extends UIComponentCSSStyle
{
   getProfileImageDivCSSStyle():object;
   getProfileNameDivCSSStyle():object;
   getContactNumberDivCSSStyle():object;
   getProfileStatusDivCSSStyle():object;

   getMobileWrapperCSSStyle(): object;
   getMobileProfileImageDivCSSStyle():object;
   getMobileProfileNameDivCSSStyle():object;
   getMobileContactNumberDivCSSStyle():object;
   getMobileProfileStatusDivCSSStyle():object;
}

export class MyProfileDetailsCSSStyleImpl extends UIComponentCSSStyleImpl implements MyProfileDetailsCSSStyle
{
    getWrapperCSSStyle(): object
    {
        return {
            width:'210px',
            height:'100%',
            flex:'1',
            // backgroundColor:this.getResources().getColor(Colors.color_5),
            itemAlign:'center',
            // margin:"20px 120px 50px 0px"
            
        };
    }

    getProfileImageDivCSSStyle():object
    {
        return{
              width:'139px',
              height:'139px',
              margin:'0px 0px 10px 35px',
              
        };
    }

    getProfileNameDivCSSStyle():object
    {
        return{
            width:'100%',
            textAlign:"center",
            itemAlign:'center',
            height:'30px',
            color:'#000000',
            lineHeight:'30px',
            letterSpacing:'0px',
            fontFamily:this.getResources().getFontFamily(),
            fontSize:'20px',
            fontWeight:900,
            margin:'0px auto',
        };
    }


    getContactNumberDivCSSStyle():object
    {
        return{
            width:'100%',
            textAlign:'center',
            display:'block',
            height:'45px',
            color:'#000000',
            lineHeight:'26px',
            letterSpacing:'0px',
            fontFamily:this.getResources().getFontFamily(),
            fontSize:'19px',
            fontWeight:500,
            margin:'0px 0px 5px 0px'
        };
    }

    getProfileStatusDivCSSStyle():object
    {
        return{
            height:'34px',
            width:'100%',
            color:this.getResources().getColor(Colors.color_36),
            textAlign:'center',
            lineHeight:'33.6px',
            letterSpacing:'0px',
            fontSize:'17px',
            marginLeft:'0px',
            fontFamily:this.getResources().getFontFamily(),
            fontWeight:"900"
        };
    }


    getMobileWrapperCSSStyle(): object
    {
        return {
            width:'210px',
            height:'100%',
            flex:'1',
            display: "inline-block",
            textAlign: "center",
            // backgroundColor:this.getResources().getColor(Colors.color_5),
            itemAlign:'center',
            // margin:"20px 120px 50px 0px"
            
        };
    }

    getMobileProfileImageDivCSSStyle():object
    {
        return{
              width:'64px',
              height:'64px',
              margin:'0px 0px 10px 75px',
              
        };
    }

    getMobileProfileNameDivCSSStyle():object
    {
        return{
            width:'100%',
            textAlign:"center",
            itemAlign:'center',
            height:'30px',
            color:'#000000',
            lineHeight:'30px',
            letterSpacing:'0px',
            fontFamily:this.getResources().getFontFamily(),
            fontSize:'20px',
            fontWeight:900,
            margin:'0px auto',
        };
    }


    getMobileContactNumberDivCSSStyle():object
    {
        return{
            width:'100%',
            textAlign:'center',
            display:'block',
            height:'45px',
            color:'#000000',
            lineHeight:'26px',
            letterSpacing:'0px',
            fontFamily:this.getResources().getFontFamily(),
            fontSize:'19px',
            fontWeight:500,
            margin:'0px 0px 5px 0px'
        };
    }

    getMobileProfileStatusDivCSSStyle():object
    {
        return{
            height:'25px',
            width:'100%',
            color:this.getResources().getColor(Colors.color_36),
            textAlign:'center',
            lineHeight:'17.6px',
            letterSpacing:'0px',
            fontSize:'12px',
            marginLeft:'0px',
            fontFamily:this.getResources().getFontFamily(),
            fontWeight:"900"
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/myaccount/myprofiledetails/myprofiledetailscss.tsx